import React, { Component } from 'react';
import { Modal, Row, Divider, Col, Button, Table, Input, Tag, Tooltip, Icon, Form, InputNumber, Switch } from 'antd';

import Image from '../../ui/Image';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import axios from 'axios';
import { encodeGb2312 } from '../../../util/gb2312'

//加载中遮罩
import Loading from '../../ui/Loading';

import TicketEdit from './TicketEdit';

class TicketPrint extends Component {

    columns = [
        {
            title: '开票时间',
            dataIndex: 'billingTime',
            width: '20%',
        }, {
            title: '发票号码',
            dataIndex: 'invoiceNo',
            width: '25%',
        }, {
            title: '服务费用',
            dataIndex: 'commission',
            width: '15%',
        }, {
            title: '开票人',
            dataIndex: 'drawer',
            width: '15%',
        }, {
            title: '票据状态',
            dataIndex: 'state',
            width: '10%',
            render: (text) => text === 1 ?
                (<Tag color="#108ee9">已开票</Tag>)
                : text === 2 ?
                    (<Tag color="#ff5500">已作废</Tag>)
                    : text === 3 ?
                        (<Tag color="#ff5500">自带票</Tag>)
                        :
                        (<Tag>未开票</Tag>)
        }, {
            title: '备注',
            dataIndex: 'remark',
            width: '20%',
            render: (text, record, index) => (
                <Tooltip title={text}>
                    <span>{text}</span>
                </Tooltip>
            )
        }, {
            title: '操作',
            dataIndex: 'id',
            width: '15%',
            render: (text, record, index) => (
                <div>
                    {
                        record.state === 3 ? ''
                            : (<Tooltip title="修改服务费用">
                                <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.editCommission.bind(this, text)} />
                            </Tooltip>)
                    }
                    {
                        record.state === 3 ? ''
                            : (<Tooltip title="作废交易票">
                                <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.showScrapModal.bind(this, text)} />
                            </Tooltip>)
                    }
                </div>
            )
        }];

    state = {
        fileList: {},
        printVisible: false,    //显示税票打印结果反馈框
        scrapVisible: false,    //交易票作废说明输入框
        scrapTicketId: '',
        ticketList: [],

        //交易票相关信息修改
        editVisible: false,

        invoiceNo: '',

        needDeduction: false, //是否需要补扣款

        editCommissionVisible: false,
        editTicketId: {},

    }

    // onRef = (ref) => {
    //     this.ticket = ref
    // }
    //打印交易票
    printTicket = () => {
        let data = this.props.ticketData;
        if (data.commission == null || data.tradeVehicleType == null) {
            messager.alert("请先在修改中选择业务类型和服务费用", "提示", "error");
            return;
        }
        if (data.invoiceState === 3 || data.invoiceState === "3") {
            messager.alert("这条流水已经被修改为自带交易票了，不能打印交易票", "提示", "error");
            return;
        }

        // let params = ""
        //     + "0=" + encodeGb2312(data["buyer.name"])
        //     + "&1=" + data["buyer.creditNo"]
        //     + "&2=" + encodeGb2312(data["buyer.residenceAddress"])
        //     + "&3=" + data["buyer.tel"]
        //     + "&4=" + encodeGb2312(data["seller.name"])
        //     + "&5=" + data["seller.creditNo"]
        //     + "&6=" + encodeGb2312(data["seller.residenceAddress"])
        //     + "&7=" + data["seller.tel"]
        //     + "&8=" + encodeGb2312(data["vehicle.plateNo"])
        //     + "&9=" + data["vehicle.registerNo"]
        //     + "&10=" + encodeGb2312(data["vehicleTypeStr"])
        //     + "&11=" + encodeGb2312(data["vehicle.vin"])
        //     + "&12=" + encodeGb2312(data["vehicle.brandModel"])
        //     + "&13=" + encodeGb2312(data["destination"])
        //     + "&14=" + data["amount"]
        //     ;
        let params = {
            0: "1",
            1: encodeGb2312(data["buyer.name"]),
            2: data["buyer.creditNo"],
            3: encodeGb2312(data["buyer.residenceAddress"]),
            4: data["buyer.tel"],
            5: encodeGb2312(data["seller.name"]),
            6: data["seller.creditNo"],
            7: encodeGb2312(data["seller.residenceAddress"]),
            8: data["seller.tel"],
            9: encodeGb2312(data["vehicle.plateNo"]),
            10: data["vehicle.registerNo"],
            11: encodeGb2312(data["vehicleTypeStr"]),
            12: encodeGb2312(data["vehicle.vin"]),
            13: encodeGb2312(data["vehicle.brandModel"]),
            14: encodeGb2312(data["destination"]),
            15: data["amount"]
        };

        axios.request({
            url: 'http://localhost:9999',
            method: 'post',
            params: params
        }).then((response) => {
            if (response != null && response.data != null && response.data !== "") {
                this.setState({ invoiceNo: response.data });
            } else {
                http.post({
                    url: '/application/findMaxInvoiceNo',
                    data: { applicationId: data.applicationId },
                    success: (res) => {
                        this.setState({ invoiceNo: res });
                    }
                });
            }
        })
            .catch((response) => {
                console.info("获取信息异常");
                console.info(response);
                http.post({
                    url: '/application/findMaxInvoiceNo',
                    data: { applicationId: data.applicationId },
                    success: (res) => {
                        this.setState({ invoiceNo: res });
                    }
                });
            });

        //回显反馈界面
        this.showModal();
    }

    componentWillReceiveProps(that) {
        if (that.visible) {
            let image = that.ticketData.image;
            let fileList = {};
            if (image != null) {
                let fileKeys = ["buyerCreditFront", "sellerCreditFront", "vehicleLicense", "vehicleRegister", "vehicleRegister_1"];
                //let fileList = this.state.fileList;
                for (let i in fileKeys) {
                    let key = fileKeys[i];
                    if (image[key] !== undefined && image[key] != null && image[key] !== "") {
                        fileList[key] = "data:image/jpeg;base64," + image[key].replace(/\r\n/g, "");
                    }
                }
                //this.setState({ fileList: fileList });
            }
            let ticketList = that.ticketData["ticket"] == null ? [] : that.ticketData["ticket"];
            that.ticketData["disabledCommission"] = false;
            that.ticketData["needDeduction"] = false;
            let needDeduction = false;
            if (ticketList != null && ticketList.length > 0) {
                needDeduction = true;
                that.ticketData["needDeduction"] = true;
                if (ticketList.length > 1) {
                    that.ticketData["disabledCommission"] = true;
                }
            }
            if (that.ticketData.invoiceState === 3 || that.ticketData.invoiceState === "3") {
                that.ticketData["selfTicket"] = 1;
            }
            this.setState({ ticketList: ticketList, fileList: fileList, "needDeduction": needDeduction });
        }
    }

    showModal = () => {
        this.setState({ printVisible: true });
    }
    hiddenModal = () => {
        this.setState({ printVisible: false, invoiceNo: null });
    }
    showScrapModal = (info, e) => {
        this.setState({ scrapVisible: true, scrapTicketId: info });
    }
    hiddenScrapModal = () => {
        this.setState({ scrapVisible: false });
    }
    editCommission = (info, e) => {
        this.setState({ editCommissionVisible: true, editTicketId: info });
    }
    hiddenEditCommission = () => {
        this.setState({ editCommissionVisible: false });
    }

    reloadData = () => {
        http.post({
            url: '/application/findTicket',
            data: { applicationId: this.props.ticketData.applicationId },
            success: (res) => {
                let ticketList = res == null ? [] : res;
                let needDeduction = false;
                if (ticketList != null && ticketList.length > 0) {
                    needDeduction = true;
                    this.props.ticketData["needDeduction"] = true;
                    if (ticketList.length > 1) {
                        this.props.ticketData["disabledCommission"] = true;
                    }
                    if (ticketList[0].state === 3 || ticketList[0].state === "3") {
                        this.props.ticketData["selfTicket"] = 1;
                        this.props.ticketData["invoiceState"] = 3;
                    }
                }
                this.setState({ ticketList: ticketList, "needDeduction": needDeduction });
            }
        });
    }

    hiddenEditModal = () => {
        this.setState({ editVisible: false });
    }

    onTicketEdit = () => {
        const { ticketData } = this.props;
        this.initTicketEdit(0, ticketData["seller.creditNo"]);
        this.setState({ editVisible: true });
    }

    render() {
        const { visible, onCancel, ticketData } = this.props;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="打印交易票"
                okText="打印"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.printTicket}
                footer={[
                    //  <Button key="cancel" onClick={onCancel}>取消</Button>,
                    // <Button key="edit" type="primary" onClick={() => this.setState({ editVisible: true })}>修改</Button>,
                    // <Button key="print" type="primary" onClick={this.printTicket}>打印</Button>,
                ]}
            >
                <div>
                    <Row>
                        <Col style={{ textAlign: "right" }}>
                            <Button key="edit" type="primary" style={{ margin: '0 10px' }} onClick={this.onTicketEdit}>修改</Button>
                            <Button key="print" type="primary" onClick={this.printTicket}>打印</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Divider orientation="left">交易信息</Divider>
                        <Col span={24}>
                            <Row>
                                <Col span={2} style={titleStyle}>业务类型：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["tradeVehicleTypeStr"]}</Col>
                                <Col span={2} style={titleStyle}>服务费用：</Col>
                                <Col span={3} style={contentStyle}>{ticketData["commission"]}</Col>
                                <Col span={2} style={titleStyle}>车价合计：</Col>
                                <Col span={3} style={contentStyle}>{ticketData["amount"]}</Col>
                                <Col span={3} style={titleStyle}>车辆转入地：</Col>
                                <Col span={4} style={contentStyle}>{ticketData["destination"]}</Col>
                            </Row>
                            <Row>
                                <Col span={2} style={titleStyle}>是否代办：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["agent"] === 1 ? '是' : '否'}</Col>
                                <Col span={2} style={titleStyle}>代办公司：</Col>
                                <Col span={8} style={contentStyle}>{ticketData["agencyName"]}</Col>
                                <Col span={3} style={titleStyle}>代办人员：</Col>
                                <Col span={4} style={contentStyle}>{ticketData["agentManName"]}</Col>
                            </Row>
                        </Col>
                        <Divider orientation="left">车辆信息</Divider>
                        <Col span={24}>
                            <Row>
                                <Col span={3} style={titleStyle}>车牌号码：</Col>
                                <Col span={4} style={contentStyle}>{ticketData["vehicle.plateNo"]}</Col>
                                <Col span={3} style={titleStyle}>车架号：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["vehicle.vin"]}</Col>
                                <Col span={4} style={titleStyle}>登记证书编号：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["vehicle.registerNo"]}</Col>
                            </Row>
                            <Row>
                                <Col span={3} style={titleStyle}>车辆类型：</Col>
                                <Col span={4} style={contentStyle}>{ticketData["vehicleTypeStr"]}</Col>
                                <Col span={3} style={titleStyle}>厂牌品牌：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["vehicle.brandModel"]}</Col>
                            </Row>

                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col span={3}>
                                    <Image
                                        onlyView={true}
                                        file={this.state.fileList.vehicleLicense}
                                        text={'行驶证'}
                                        url={ticketData["imageUrl.vehicleLicense"]}
                                    />
                                </Col>
                                <Col span={3}>
                                    <Image
                                        onlyView={true}
                                        file={this.state.fileList.vehicleRegister}
                                        text={'机动车登记证首页'}
                                        url={ticketData["imageUrl.vehicleRegister"]}
                                    />
                                </Col>
                                <Col span={3}>
                                    <Image
                                        onlyView={true}
                                        file={this.state.fileList.vehicleRegister_1}
                                        text={'机动车登记证尾页'}
                                        url={ticketData["imageUrl.vehicleRegister_1"]}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Divider orientation="left">买方信息</Divider>
                        <Col span={21}>
                            <Row><Col span={24}>
                                <Col span={3} style={titleStyle}>买方姓名：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["buyer.name"]}</Col>
                                <Col span={3} style={titleStyle}>证件号：</Col>
                                <Col span={13} style={contentStyle}>{ticketData["buyer.creditNo"]}</Col>
                            </Col></Row>
                            <Row><Col span={24}>
                                <Col span={3} style={titleStyle}>手机号：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["buyer.tel"]}</Col>
                                <Col span={3} style={titleStyle}>联系地址：</Col>
                                <Col span={13} style={contentStyle}>{ticketData["buyer.residenceAddress"]}</Col>
                            </Col></Row>
                        </Col>
                        <Col span={3}>
                            <Image
                                onlyView={true}
                                file={this.state.fileList.buyerCreditFront}
                                text={'买家身份证（头像）'}
                                url={ticketData["imageUrl.buyerCreditFront"]}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Divider orientation="left">卖方信息</Divider>
                        <Col span={21}>
                            <Row><Col span={24}>
                                <Col span={3} style={titleStyle}>卖方姓名：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["seller.name"]}</Col>
                                <Col span={3} style={titleStyle}>证件号：</Col>
                                <Col span={13} style={contentStyle}>{ticketData["seller.creditNo"]}</Col>
                            </Col></Row>
                            <Row><Col span={24}>
                                <Col span={3} style={titleStyle}>手机号：</Col>
                                <Col span={5} style={contentStyle}>{ticketData["seller.tel"]}</Col>
                                <Col span={3} style={titleStyle}>联系地址：</Col>
                                <Col span={13} style={contentStyle}>{ticketData["seller.residenceAddress"]}</Col>
                            </Col></Row>
                        </Col>
                        <Col span={3}>
                            <Image
                                onlyView={true}
                                file={this.state.fileList.sellerCreditFront}
                                text={'卖家身份证（头像）'}
                                url={ticketData["imageUrl.sellerCreditFront"]}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Divider orientation="left">交易票打印记录</Divider>
                        <Table rowKey="id" columns={this.columns} dataSource={this.state.ticketList} pagination={false} />
                    </Row>
                    {/* 税控软件写入插件 */}
                    {/* <TicketPlugin
                        onRef={this.onRef}
                    /> */}
                    {/* 写入完成后，人工确认是否开票成功 */}
                    <PrintTicket
                        visible={this.state.printVisible}
                        onCancel={this.hiddenModal}
                        applicationId={ticketData.applicationId}
                        invoiceNo={this.state.invoiceNo}

                        closeModal={onCancel} //用于打印成功后关闭窗口

                        needDeduction={this.state.needDeduction} //是否需要补扣款

                        reloadData={this.reloadData}
                        successCallback={this.props.successCallback}
                        queryData={this.props.queryData}
                    />
                    <ScrapTicket
                        visible={this.state.scrapVisible}
                        onCancel={this.hiddenScrapModal}
                        ticketId={this.state.scrapTicketId}
                        reloadData={this.reloadData}
                        successCallback={this.props.successCallback}
                        queryData={this.props.queryData}
                    />

                    <TicketEdit
                        visible={this.state.editVisible}
                        onCancel={this.hiddenEditModal}
                        editData={ticketData}
                        successCallback={this.props.successCallback}
                        queryData={this.props.queryData}
                        reloadData={this.reloadData}
                        initEdit={(func) => { this.initTicketEdit = func }}
                    //reloadData={this.reloadData}
                    //successCallback={this.props.successCallback}
                    // queryData={this.props.queryData}
                    />
                    <EditTicket
                        visible={this.state.editCommissionVisible}
                        onCancel={this.hiddenEditCommission}
                        editTicketId={this.state.editTicketId}
                        reloadData={this.reloadData}
                        successCallback={this.props.successCallback}
                        queryData={this.props.queryData}
                    />
                </div>
            </Modal>
        );
    }
}

const titleStyle = {
    fontWeight: 'bold',
    padding: '10px 0'
};

const contentStyle = {
    padding: '10px 0',
    textAlign: 'left'
}


const fields = [{
    "text": "发票号码",
    "field": "invoiceNo",
    rules: [
        { required: true, message: '作发票号码不能为空!' },
        { max: 64, message: '发票号码不能超过32个字符！' },
    ]
}, {
    "text": "需收取补扣款",
    "field": "needDeduction",
    radio: true,
    needDeduction: true,
}, {
    "text": "补扣金额",
    "field": "commission",
    number: true,
    needDeduction: true,
    selfCtrl: true,
    rules: [
        { required: true, message: '补扣金额不能为空!' },
    ]
}, {
    "text": "备注/补扣原因",
    "field": "remark",
    textarea: true,
    // needDeduction: true,
    // selfCtrl: true,
    rules: [
        { required: true, message: '补扣原因不能为空!' },
    ]
}];

class PrintTicketForm extends Component {

    state = {
        needDeduction: true,
        loadingVisible: false
    }

    //打印交易票成功，保存数据到后台
    ticketPrintSuccess = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });
            if (values["needDeduction"] != null) {
                values["needDeduction"] = values["needDeduction"] === true ? 1 : 0;
            }
            values["applicationId"] = this.props.applicationId;
            http.post({
                url: '/application/saveTicketInfo',
                data: values,
                success: (res) => {

                    messager.notify("保存票据信息成功！");
                    //this.props.reloadData();
                    // this.props.onCancel();
                    this.cancel();
                    this.props.closeModal();
                    this.props.successCallback(this.props.queryData);
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    }

    //swith选择改变时触发
    radioChange = (field, checked) => {
        if (field === "needDeduction") {
            this.setState({ "needDeduction": checked });
        }
    }

    createDom = (data) => {
        const { form, needDeduction } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let rules = item.rules;
            if (item["needDeduction"] === true && !(needDeduction === true)) {
                continue;
            }
            if (!this.state.needDeduction && item.selfCtrl) {
                continue;
            }
            if(item["field"] === "remark"){
                if(!needDeduction){
                    rules = [];
                }else if(!this.state.needDeduction){
                    //此时的备注信息为非必填
                    rules = [];
                }
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: rules,
                            initialValue: item.radio ? needDeduction : this.props[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.radio ?
                                <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange.bind(this, item.field)} />
                                : item.number ?
                                    <InputNumber precision={2} min={0.00} max={999999999} style={{ width: '100%' }} />
                                    : item.textarea ? <Input.TextArea />
                                        : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    cancel = () => {
        this.setState({ needDeduction: true });
        const { onCancel } = this.props;
        onCancel();
    }

    render() {
        const { visible } = this.props;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="交易票打印结果反馈"
                okText="打印成功"
                cancelText="打印失败"
                maskClosable={false}
                onCancel={this.cancel}
                onOk={this.ticketPrintSuccess}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        {/* <Form.Item label="发票号码：">
                            {getFieldDecorator('invoiceNo', {
                                initialValue: this.props.invoiceNo,
                                rules: [
                                    { required: true, message: '作发票号码不能为空!' },
                                    { max: 64, message: '发票号码不能超过32个字符！' },
                                ]
                            })(<Input />)}
                        </Form.Item> */}
                        {this.createDom(fields)}
                    </Form>
                </Row>
                <Loading
                    visible={this.state.loadingVisible}
                    message="保存中..."
                />
            </Modal>
        )
    }
}


class ScrapTicketForm extends Component {
    //作废交易票
    scrapTicket = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["ticketId"] = this.props.ticketId;
            http.post({
                url: '/application/scrapTicket',
                data: values,
                success: (res) => {
                    messager.notify("作废交易票成功！");
                    this.props.reloadData();
                    this.props.onCancel();
                    this.props.successCallback(this.props.queryData);
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="作废交易票"
                okText="作废"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.scrapTicket}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="作废理由：">
                            {getFieldDecorator('remark', {
                                rules: [
                                    { required: true, message: '作废理由不能为空!' },
                                    { max: 64, message: '作废理由不能超过64个字符！' },
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Form>
                </Row>
            </Modal>
        )
    }
}


class EditTicketForm extends Component {
    //修改交易票服务费用
    updateTicketCommission = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["ticketId"] = this.props.editTicketId;
            http.post({
                url: '/application/updateTicketCommission',
                data: values,
                success: (res) => {
                    messager.notify("修改交易票服务费用成功！");
                    this.props.reloadData();
                    this.props.onCancel();
                    this.props.successCallback(this.props.queryData);
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="修改交易票服务费用"
                okText="确认"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.updateTicketCommission}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="服务费用：">
                            {getFieldDecorator('commission', {
                                rules: [
                                    { required: true, message: '服务费用不能为空!' },
                                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入合法的数字并最多保留两位小数' }
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Form>
                </Row>
            </Modal>
        )
    }
}


const ScrapTicket = Form.create()(ScrapTicketForm);
const PrintTicket = Form.create()(PrintTicketForm);
const EditTicket = Form.create()(EditTicketForm);


export default TicketPrint;
